webpackJsonp([107621781700308],{

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Article = __webpack_require__(13);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Block = __webpack_require__(5);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Figure = __webpack_require__(10);
	
	var _Figure2 = _interopRequireDefault(_Figure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var frontmatter = exports.frontmatter = {
	  id: 'localhost',
	  isWork: true,
	  subtitle: 'localhost',
	  title: 'Host and connect with your co-workers around the world',
	  date: '2018-12-12',
	  cover: './localhost.png',
	  path: '/work/localhost',
	  excerpt: '',
	  details: [{
	    title: 'Responsibility',
	    description: 'Co-Founder, Brand, Product Design, Frontend'
	  }, {
	    title: 'Date',
	    description: 'Since 2016'
	  }, {
	    title: 'Technology',
	    description: 'Figma, React, Apollo'
	  }]
	};
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Article2.default,
	    props,
	    _react2.default.createElement(
	      _Block2.default,
	      { mobilePull: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Together with team of current and previous Google employees, I co-founded a platform that helps Googlers host and connect with their co-workers when they\u2019re on business or leisure trips.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'In 2019, We decided to completely rebuild the platform. I took charge of the brand, design, and frontend development. The design process was very much focused on making it as easy as possible to build and relaunch the web application.'
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true, pull: true, align: 'center' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Brand'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'A new, friendly face for localhost.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'center', pull: true },
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.logo }),
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.landing })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true, pull: true, align: 'center' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The Platform'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Using the learnings from our extensive MVP, I was able to design a platform focused on what\u2019s needed most, free from any distractions.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'center', pull: true },
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.ui1 }),
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.ui2 })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.focus })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true, align: 'right' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Refining the frontend'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Analyzing the behaviors of our users over the course of two years, I was able to confidently design the next version of localhost, aiming to improve both the experience of listing and booking apartments.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Building a system'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Using Storybook for React, I built a living style guide including not only colors and brand information, but also the documentation of components that are used throughout the application.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true, align: 'right' },
	      _react2.default.createElement(_Figure2.default, { link: true, sizes: props.data.styleguide })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-articles-localhost-index-js-54b62d223c09388fa187.js